/* live-match (Robin 21 Oct): desktop image zoom — clicking a picture switches ALL pictures to full size,
   so the customer can keep scrolling from one full-size picture to the next without closing the zoom.
   Click again (or close / Esc / thumbnail) to return to the fitted view. Mobile (<1024px) unchanged. */
(function () {
  var MODE = 'lm-zoom-all';
  function box() { return document.querySelector('.popup-zoomed-images'); }
  function desktop() { return window.innerWidth >= 1024; }
  function currentSlide(c) {
    var slides = c.querySelectorAll('.product-zoomed-img'), mid = c.scrollTop + c.clientHeight / 2, hit = slides[0];
    for (var i = 0; i < slides.length; i++) { if (slides[i].offsetTop <= mid) hit = slides[i]; }
    return hit;
  }
  function exit(c, keepPlace) {
    if (!c || !c.classList.contains(MODE)) return;
    var s = keepPlace ? currentSlide(c) : null;
    c.classList.remove(MODE);
    if (s) c.scrollTop = s.offsetTop;
  }
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest && e.target.closest('.popup-zoomed-images .product-desk-zoom-wrap');
    if (!wrap || !desktop()) return;
    var c = box(); if (!c) return;
    e.stopPropagation(); e.preventDefault();
    var slide = wrap.closest('.product-zoomed-img');
    if (c.classList.contains(MODE)) { exit(c, true); return; }
    /* remember where in the picture the click was, then keep that point under the cursor */
    var img = wrap.querySelector('img, video') || wrap;
    var r = img.getBoundingClientRect();
    var fy = r.height ? Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)) : 0.5;
    var fx = r.width ? Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)) : 0.5;
    c.querySelectorAll('.product-zoomed-img.is-zoomed').forEach(function (el) { el.classList.remove('is-zoomed'); el.scrollTop = 0; });
    c.classList.remove('zoomPopupScrollHide');
    c.classList.add(MODE);
    requestAnimationFrame(function () {
      var ir = img.getBoundingClientRect(), cr = c.getBoundingClientRect();
      c.scrollTop = Math.max(0, slide.offsetTop + fy * ir.height - (e.clientY - cr.top));
      c.scrollLeft = Math.max(0, fx * ir.width - (e.clientX - cr.left));
    });
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.z-popup-close')) exit(box(), false);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') exit(box(), false); });
  /* keep the thumbnail highlight in step with the picture in view (desktop, fitted and full-size view) */
  var tick = false;
  document.addEventListener('scroll', function (e) {
    var c = e.target;
    if (!desktop() || !c.classList || !c.classList.contains('popup-zoomed-images') || tick) return;
    tick = true;
    requestAnimationFrame(function () {
      tick = false;
      var slides = Array.prototype.slice.call(c.querySelectorAll('.product-zoomed-img'));
      var cur = currentSlide(c), idx = slides.indexOf(cur);
      var thumbs = document.querySelectorAll('.popup-zoomed-thumb-images .swiper-slide');
      if (idx < 0 || !thumbs[idx] || thumbs[idx].classList.contains('swiper-slide-thumb-active')) return;
      thumbs.forEach(function (t, i) { t.classList.toggle('swiper-slide-thumb-active', i === idx); });
      var ts = document.querySelector('.popup-zoomed-thumb-images');
      if (ts && ts.swiper) ts.swiper.slideTo(idx, 300);
    });
  }, true);
})();

/* live-match (Robin 21 Oct): "Notify me when back in stock" — port of live's #backInStockBtn handler
   (live templates/product.liquid). Size-list "Notify me" sets the variant; the form posts to
   Shop Circle Back in Stock. (Lives in this product-only file to avoid another script tag.) */
(function () {
  function wrap() { return document.querySelector('#backInStock .back-in-stock-wrapper'); }
  function setVariant(id, title, priceHtml) {
    var w = wrap(); if (!w || !id) return;
    w.setAttribute('data-var-id', id);
    var d = document.getElementById('backInStock');
    var v = d && d.querySelector('.bkis_variant'); if (v && title) v.textContent = title;
    var p = d && d.querySelector('.bkis_price'); if (p && priceHtml) p.innerHTML = priceHtml;
    var m = document.getElementById('backInStockMsg'); if (m) { m.textContent = ''; m.classList.add('hidden'); }
    var b = document.getElementById('backInStockBtn');
    if (b && b.getAttribute('data-lm-label')) { b.textContent = b.getAttribute('data-lm-label'); b.disabled = false; b.classList.remove('lm-bis-done'); done = false; }
  }
  document.addEventListener('click', function (e) {
    var n = e.target.closest && e.target.closest('.notify-me-stock');
    if (!n) return;
    var o = n.closest('[varid]');
    if (o) setVariant(o.getAttribute('varid'), o.getAttribute('data-variant-title'), o.getAttribute('data-price'));
  }, true);
  function say(msg, ok) {
    var m = document.getElementById('backInStockMsg'); if (!m) return;
    m.textContent = msg; m.style.color = ok ? 'green' : 'red'; m.classList.remove('hidden');
  }
  var busy = false, done = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#backInStockBtn');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    var w = wrap(), input = document.getElementById('backInStockEmail'), accept = document.getElementById('notify_accept');
    if (!w || !input) return;
    var email = input.value.trim();
    var vid = w.getAttribute('data-var-id') || new URLSearchParams(location.search).get('variant');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say('Please enter your email.'); return; }
    if (!vid) { say('Please select a size.'); return; }
    if (accept && !accept.checked) { say('Please accept the terms and conditions.'); return; }
    if (window.lmResetZoom) window.lmResetZoom();
    if (!btn.getAttribute('data-lm-label')) btn.setAttribute('data-lm-label', btn.textContent);
    busy = true; btn.disabled = true;
    fetch('https://back-in-stock.shopcircle.co/api/public/subscribe/email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        domain: window.Shopify && Shopify.shop, product_id: Number(w.getAttribute('data-pro-id')), variant_id: Number(vid),
        destination: email, alertType: 'email', country: window._ks_countryCodeFromIPCOuntry, marketing: true
      })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      var m = document.getElementById('backInStockMsg'); if (m) { m.textContent = ''; m.classList.add('hidden'); }
      btn.textContent = 'YOU’LL BE NOTIFIED'; btn.classList.add('lm-bis-done'); done = true;
    }).catch(function () {
      say('Something went wrong. Please try again.');
    }).then(function () { busy = false; btn.disabled = done; });
  }, true);
})();

/* live-match (Robin 21 Oct): SIZE CHART without a Kiwi chart -> show the static conversion table
   (.lm-static-sc in snippets/product-drawers.liquid) instead of the "Oops" message. */
(function () {
  function drawer() { return document.getElementById('eusizeChart'); }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var d = drawer(); if (!d) return;
    var tg = e.target.closest('.measure-info-toggle');
    /* no flash of the other tab: switch the Kiwi tab right away (the theme does it 200 ms later) */
    var opener = tg || e.target.closest('[data-drawer="eusizeChart"], .eu-measurements, .productInfo_measurements');
    if (opener) {
      var heads = d.querySelectorAll('.ks-tab-header');
      var want = heads[tg ? 1 : 0];
      if (want && !want.classList.contains('ks-tab-header-selected')) want.click();
    }
    if (tg) {
      /* drawer title = the link's own text ("SIZE CHART", translated), not "MEASUREMENTS" (Robin 22 Oct) */
      var label = tg.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
      if (label) d.querySelectorAll('.drawer-measure-heading').forEach(function (h) { h.textContent = label; });
      setTimeout(function () {
        d.querySelectorAll('.drawer-sizechart-heading').forEach(function (h) { h.style.display = 'none'; });
        d.querySelectorAll('.drawer-measure-heading').forEach(function (h) { h.style.display = 'block'; });
      }, 0);
      var hasKiwi = !!document.querySelector('#KiwiSizingChart .ks-tab-panel');
      d.classList.toggle('lm-sc-static', !hasKiwi && !!d.querySelector('.lm-static-sc'));
    } else if (e.target.closest('[data-drawer="eusizeChart"]')) {
      d.classList.remove('lm-sc-static');
      setTimeout(function () {
        d.querySelectorAll('.drawer-measure-heading').forEach(function (h) { h.style.display = 'none'; });
        d.querySelectorAll('.drawer-sizechart-heading').forEach(function (h) { h.style.display = 'block'; });
      }, 0);
    }
  }, true);
})();

/* live-match (Robin 22 Oct, mobile/tablet <=1023px): info badges (Permanent / Pre-Order / Sold Out) move below
   "Product info / Shipping & Returns"; desktop keeps them under the price. Spacing: live-match-global.css. */
(function () {
  var mq = window.matchMedia('(max-width: 1023px)');
  var mark = null;
  function place() {
    var box = document.querySelector('.product__info-container');
    var badge = box && box.querySelector('.productInfo_badge_label');
    var acc = box && box.querySelector('.collapse-content-row');
    if (!badge || !acc) return;
    if (!mark) { mark = document.createComment('lm-badge-home'); badge.parentNode.insertBefore(mark, badge); }
    if (mq.matches) { if (badge.previousElementSibling !== acc) acc.parentNode.insertBefore(badge, acc.nextSibling); badge.classList.add('lm-badge-moved'); }
    else { if (mark.nextSibling !== badge) mark.parentNode.insertBefore(badge, mark.nextSibling); badge.classList.remove('lm-badge-moved'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  if (mq.addEventListener) mq.addEventListener('change', place);
})();
